module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "milestones"
  }, _vm._l((_vm.milestones), function(milestone) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "date-col highlight"
    }, [_c('span', {
      staticClass: "dot"
    }), _vm._v(" "), _c('span', {
      staticClass: "date-text"
    }, [_vm._v(_vm._s(_vm.$t("milestones." + milestone + ".date")))]), _vm._v(" "), _c('p', {
      staticClass: "desc"
    }, [_c('b', [_vm._v(_vm._s(_vm.$t("milestones." + milestone + ".title")))]), _c('br'), _vm._v(_vm._s(_vm.$t("milestones." + milestone + ".desc")) + "\n\t\t\t")])])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8908b930!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Milestones.vue
// module id = 425
// module chunks = 2